function TextSlide(id, parent){

    var self = this;

    this.parent = parent;

    this.id = id;

    var text = "#t"+this.id;

    this.$text = $(text);

    this.length = 2;

}

TextSlide.prototype.getTimeline = function (){

    var self = this;

    var timeLine = new TimelineMax();

    timeLine

        .to(self.$text, 0.5, {autoAlpha:1},0.5)
        .to(self.$text, 0.5, {autoAlpha:0},4)
    ;

    return timeLine;

};

